import React, { useEffect, useState } from 'react';
import './Footer.css';
import styled from 'styled-components';
import { colors } from '../../styles/colors';

const FooterLogo = styled.img`
  width: 120px;
  height: 120px;
  margin-bottom: 30px;
  border-radius: 50%;
  background: white;
  padding: 5px;
  transition: transform 0.5s ease;

  &:hover {
    transform: scale(1.55);
  }
`;

const FooterLogoContainer = styled.div`
  text-align: center;
  margin-bottom: 40px;
  
  &:after {
    content: 'Balrajeshwar Real Estate Pvt. Ltd.';
    display: block;
    color: white;
    font-size: 1.2rem;
    margin-top: 15px;
    font-weight: 500;
  }
`;

const StickyFooter = styled.div`
  position: sticky;
  bottom: 0;
  width: 100%;
  background: ${colors.primary};
  color: white;
  padding: 15px 0;
  text-align: center;
  z-index: 100;
  
  a {
    color: white;
    text-decoration: underline;
    
    &:hover {
      color: ${colors.accent};
    }
  }
`;

const BackToTop = styled.button`
  position: fixed;
  bottom: 80px;
  right: 20px;
  background: ${colors.primary};
  color: white;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  transition: all 0.3s ease;
  z-index: 1000;
  
  &:hover {
    background: ${colors.accent};
    transform: translateY(-3px);
  }
`;

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const [showSticky, setShowSticky] = useState(false);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      const windowHeight = window.innerHeight;
      const fullHeight = document.documentElement.scrollHeight;

      const scrolled = (scrollTop + windowHeight) / fullHeight;

      if (scrolled >= 0.75) {
        setShowSticky(true);
      } else {
        setShowSticky(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
      <footer className="footer">
        <div className="container">
          <div className="footer-content">
            <FooterLogoContainer>
              <FooterLogo 
                src={process.env.PUBLIC_URL + '/images/balrajeshwar-logo-circle.png'} 
                alt="Balrajeshwar Real Estate"
                width="120"
                height="120"
              />
            </FooterLogoContainer>
            
            <div className="footer-info">
              <div className="footer-section">
                <h4>Regd. Address</h4>
                <p>
                  The Orchid, Whispering Meadows,<br />
                  Agarwal Rd, Opp. Model Town,<br />
                  Ghati Pada, Mulund West,<br />
                  Mumbai, Maharashtra - 400080
                </p>
              </div>
              
              <div className="footer-section">
                <h4>Contact Us</h4>
                <p>
                  <a href="tel:+919870004341">+91 98700 04341</a><br />
                  <a href="mailto:sales@forresta.in">sales@balrajeshwar.com</a>
                </p>
              </div>
              
              <div className="footer-section">
                <h4>Quick Links</h4>
                <ul>
                  <li><a href="https://balrajeshwar.com/privacy-policy/">Privacy Policy</a></li>
                  <li><a href="https://balrajeshwar.com/tos/">Terms & Conditions</a></li>
                  <li><a href="https://balrajeshwar.com/about-us/">About Us</a></li>
                </ul>
              </div>
            </div>
            
            <div className="footer-bottom">
              <div className="copyright">
                <p>&copy; {currentYear} Balrajeshwar Real Estate Pvt. Ltd. All Rights Reserved.</p>
              </div>
              
              <div className="rera-info">
                <p>MahaRERA No.: A51800002409</p>
              </div>
              
              <div className="disclaimer">
                <p>
                  The content presented on this website is solely for informational purposes and does not constitute a service offer. 
                  Prices mentioned here are subject to change without prior notification, and the availability of the listed properties is not assured. 
                  Images showcased are illustrative and may not precisely represent the actual properties. Kindly be advised that this website operates 
                  as an authorized marketing partner (Balrajeshwar Real Estate Pvt. Ltd). For necessary processing, we may share data with Real Estate 
                  Regulatory Authority (RERA) registered brokers/companies. Additionally, updates and information may be sent to the registered mobile 
                  number or email ID. All rights reserved. This website's content, design, and data are protected by copyright and other intellectual 
                  property rights. Unauthorized use or reproduction of the content may be subject to legal repercussions. For precise and current 
                  information on services, pricing, availability, or any other details, we recommend you contact us directly via the provided contact 
                  information on this website. We appreciate your visit.
                </p>
              </div>
            </div>
          </div>
        </div>
      </footer>
      
      {showSticky && (
        <StickyFooter>
          Brought to you by Balrajeshwar Real Estate Pvt. Ltd. |{" "}
          <a href="https://www.balrajeshwar.com" target="_blank" rel="noopener noreferrer">
            [ Home Site ]
          </a>
        </StickyFooter>
      )}
      
      <BackToTop onClick={scrollToTop}>
        <i className="fas fa-arrow-up"></i>
      </BackToTop>
    </>
  );
};

export default Footer;
